module.exports = __webpack_public_path__ + "static/media/image3.65688d17.png";